export enum AggregatedPaymentStatus {
  OK = 'OK',
  OVERPAYMENT = 'OVERPAYMENT',
  OVERDUE_PAYMENT = 'OVERDUE_PAYMENT',
}
